import {
    FormGroup,
    Box,
    FormLabel,
    FormControl,
    ListItemText,
    TextField,
    Checkbox,
    FormControlLabel,
    Select,
    InputLabel,
    MenuItem,
    Button,
    ButtonGroup,
    IconButton,
  } from '@mui/material';
  import OpenInFullIcon from '@mui/icons-material/OpenInFull';
  import axios from 'axios';
  import Grid from '@mui/material/Grid';
  import PropagateLoader from 'react-spinners/PropagateLoader';
  import Backdrop from '@mui/material/Backdrop';
  import Alert from '@mui/material/Alert';
  import AlertTitle from '@mui/material/AlertTitle';
  import CheckIcon from '@mui/icons-material/Check';
  import MUIDataTable from 'mui-datatables';
  import Autocomplete from '@mui/material/Autocomplete';

  import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
  import CheckBoxIcon from '@mui/icons-material/CheckBox';
  import React, {
    useState,
    useRef,
    useContext,
    Redirect,
    useEffect,
  } from 'react';
  const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV
  
      const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
      const checkedIcon = <CheckBoxIcon fontSize="small" />;

    export default function MUICustomFilter(props) {
//(filterList, onChange, index, column) => {
    //let currIndex = -1;
    let filterList = props.filterList;
    let onChange = props.onChange;
    let index = props.index;
    let column = props.column;
    let groupByCatolog = props.groupByCatolog;
    let labelName = props.labelName;
    //console.log("groupByCatolog: in custom filter")
    //console.log(groupByCatolog)
    let deleteCategory = props.deleteCategory;
    //console.log("deleteCategory: in custom filter")
    //console.log(deleteCategory)

    return (
    
    <Autocomplete
    multiple
    id="checkboxes-tags-demo"
    disableCloseOnSelect
    options={groupByCatolog.sort((a, b) => a.deleted === deleteCategory ? -1 : 1)}
    groupBy={(option) => option.deleted}
    getOptionLabel={(option) => option.catolog}
    renderOption={(props, option, { selected }) => (
      <li {...props}>
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          style={{ marginRight: 8 }}
          checked={selected}
          name = {option.catolog}
        />
        {option.catolog}
      </li>
    )}
    
    onChange={(event, newValue) => {
      //currIndex++;
      ////console.log(currIndex);
      
      //console.log("onchange");
      filterList[index] = [...filterList[index],event.target.name];
      //filterList[index][currIndex] = event.target.name;//newValue.catolog;
      //console.log("event.target.name;: " + event.target.name)
      //console.log("filterList[index]: ");
      //console.log(filterList[index])
      ////console.log("filterList[index][0]: " + filterList[index][currIndex]);
      onChange(filterList[index], index, column);
    }}
    //renderInput={(params) => <TextField {...params} label="Catolog Number(Inventory Item)" />}
    renderInput={(params) => (
      <TextField {...params} variant="filled" label= {labelName} />
    )}
  />
 
    )
  }